// Source : https://www.data.gouv.fr/fr/datasets/etats-et-capitales-du-monde/
export enum Country {
  AFG = 'Afghanistan',
  ZAF = 'Afrique du Sud',
  ALB = 'Albanie',
  DZA = 'Algérie',
  DEU = 'Allemagne',
  AND = 'Andorre',
  AGO = 'Angola',
  ATG = 'Antigua-et-Barbuda',
  SAU = 'Arabie saoudite',
  ARG = 'Argentine',
  ARM = 'Arménie',
  AUS = 'Australie',
  AUT = 'Autriche',
  AZE = 'Azerbaidjan',
  BHS = 'Bahamas',
  BHR = 'Bahrein',
  BGD = 'Bangladesh',
  BRB = 'Barbade',
  BEL = 'Belgique',
  BLZ = 'Bélize',
  BEN = 'Bénin',
  BTN = 'Bhoutan',
  BLR = 'Biélorussie',
  MMR = 'Birmanie',
  BOL = 'Bolivie',
  BIH = 'Bosnie-Herzégovine',
  BWA = 'Botswana',
  BRA = 'Brésil',
  BRN = 'Brunei',
  BGR = 'Bulgarie',
  BFA = 'Burkina',
  BDI = 'Burundi',
  KHM = 'Cambodge',
  CMR = 'Cameroun',
  CAN = 'Canada',
  CPV = 'Cap-Vert',
  CAF = 'Centrafrique',
  CHL = 'Chili',
  CHN = 'Chine',
  CYP = 'Chypre',
  COL = 'Colombie',
  COM = 'Comores',
  COG = 'Congo',
  COD = 'République démocratique du Congo',
  COK = 'Iles Cook',
  PRK = 'Corée du Nord',
  KOR = 'Corée du Sud',
  CRI = 'Costa Rica',
  CIV = "Côte d'Ivoire",
  HRV = 'Croatie',
  CUB = 'Cuba',
  DNK = 'Danemark',
  DJI = 'Djibouti',
  DOM = 'République dominicaine',
  DMA = 'Dominique',
  EGY = 'Egypte',
  ARE = 'Emirats arabes unis',
  ECU = 'Equateur',
  ERI = 'Erythrée',
  ESP = 'Espagne',
  EST = 'Estonie',
  SWZ = 'Eswatini',
  USA = 'Etats-Unis',
  ETH = 'Ethiopie',
  FJI = 'Fidji',
  FIN = 'Finlande',
  FRA = 'France',
  GAB = 'Gabon',
  GMB = 'Gambie',
  GEO = 'Géorgie',
  GHA = 'Ghana',
  GRC = 'Grèce',
  GRD = 'Grenade',
  GTM = 'Guatémala',
  GIN = 'Guinée',
  GNQ = 'Guinée Equatoriale',
  GNB = 'Guinée-Bissao',
  GUY = 'Guyana',
  HTI = 'Haïti',
  HND = 'Honduras',
  HUN = 'Hongrie',
  IND = 'Inde',
  IDN = 'Indonésie',
  IRQ = 'Irak',
  IRN = 'Iran',
  IRL = 'Irlande',
  ISL = 'Islande',
  ISR = 'Israël',
  ITA = 'Italie',
  JAM = 'Jamaïque',
  JPN = 'Japon',
  JOR = 'Jordanie',
  KAZ = 'Kazakhstan',
  KEN = 'Kénya',
  KGZ = 'Kirghizstan',
  KIR = 'Kiribati',
  KOS = 'Kosovo',
  KWT = 'Koweït',
  LAO = 'Laos',
  LSO = 'Lésotho',
  LVA = 'Lettonie',
  LBN = 'Liban',
  LBR = 'Libéria',
  LBY = 'Libye',
  LIE = 'Liechtenstein',
  LTU = 'Lituanie',
  LUX = 'Luxembourg',
  MKD = 'Macédoine du Nord',
  MDG = 'Madagascar',
  MYS = 'Malaisie',
  MWI = 'Malawi',
  MDV = 'Maldives',
  MLI = 'Mali',
  MLT = 'Malte',
  MAR = 'Maroc',
  MHL = 'Iles Marshall',
  MUS = 'Maurice',
  MRT = 'Mauritanie',
  MEX = 'Mexique',
  FSM = 'Micronésie',
  MDA = 'Moldavie',
  MCO = 'Monaco',
  MNG = 'Mongolie',
  MNE = 'Monténégro',
  MOZ = 'Mozambique',
  NAM = 'Namibie',
  NRU = 'Nauru',
  NPL = 'Népal',
  NIC = 'Nicaragua',
  NER = 'Niger',
  NGA = 'Nigéria',
  NIU = 'Niue',
  NOR = 'Norvège',
  NZL = 'Nouvelle-Zélande',
  OMN = 'Oman',
  UGA = 'Ouganda',
  UZB = 'Ouzbékistan',
  PAK = 'Pakistan',
  PLW = 'Palaos',
  PAN = 'Panama',
  PNG = 'Papouasie-Nouvelle-Guinée',
  PRY = 'Paraguay',
  NLD = 'Pays-Bas',
  PER = 'Pérou',
  PHL = 'Philippines',
  POL = 'Pologne',
  PRT = 'Portugal',
  QAT = 'Qatar',
  ROU = 'Roumanie',
  GBR = 'Royaume-Uni',
  RUS = 'Russie',
  RWA = 'Rwanda',
  KNA = 'Saint-Christophe-et-Nieves',
  LCA = 'Sainte-Lucie',
  SMR = 'Saint-Marin',
  VCT = 'Saint-Vincent-et-les-Grenadines',
  SLB = 'Salomon',
  SLV = 'Salvador',
  WSM = 'Samoa',
  STP = 'Sao Tomé-et-Principe',
  SEN = 'Sénégal',
  SRB = 'Serbie',
  SYC = 'Seychelles',
  SLE = 'Sierra Leone',
  SGP = 'Singapour',
  SVK = 'Slovaquie',
  SVN = 'Slovénie',
  SOM = 'Somalie',
  SDN = 'Soudan',
  SDS = 'Soudan du Sud',
  LKA = 'Sri Lanka',
  SWE = 'Suède',
  CHE = 'Suisse',
  SUR = 'Suriname',
  SYR = 'Syrie',
  TJK = 'Tadjikistan',
  TZA = 'Tanzanie',
  TCD = 'Tchad',
  CZE = 'Tchéquie',
  THA = 'Thaïlande',
  TLS = 'Timor oriental',
  TGO = 'Togo',
  TON = 'Tonga',
  TTO = 'Trinité-et-Tobago',
  TUN = 'Tunisie',
  TKM = 'Turkménistan',
  TUR = 'Turquie',
  TUV = 'Tuvalu',
  UKR = 'Ukraine',
  URY = 'Uruguay',
  VUT = 'Vanuatu',
  VAT = 'Vatican',
  VEN = 'Vénézuela',
  VNM = 'Vietnam',
  YEM = 'Yémen',
  ZMB = 'Zambie',
  ZWE = 'Zimbabwé',
}
